import {combineReducers} from "redux";
import PaymentReducer from "./payment";
import BalanceReducer from "./balance";
import PackagesReducer from "./packages";
import SmsReducer from "./SMS";

export default combineReducers({
    PaymentReducer,
    BalanceReducer,
    PackagesReducer,
    SmsReducer
})